@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.profile.profile_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.profile.profile_ui.generated.resources/"

@delegate:ResourceContentHash(-930_546_483)
internal val Res.drawable.ic_settings_30: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings_30", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings_30.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-665_409_162)
internal val Res.drawable.ic_vr_glasses_48: DrawableResource by lazy {
      DrawableResource("drawable:ic_vr_glasses_48", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_vr_glasses_48.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_settings_30", Res.drawable.ic_settings_30)
  map.put("ic_vr_glasses_48", Res.drawable.ic_vr_glasses_48)
}
